import { useState } from 'react';
import Navbar from '@/components/Navbar';
import Footer from '@/components/Footer';
import SEO from '@/components/SEO';
import { Card } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@/components/ui/select';
import { Accordion, AccordionItem, AccordionTrigger, AccordionContent } from '@/components/ui/accordion';
import { Calculator, TrendingUp, CheckCircle2, ArrowRight, Info, Plus, X } from 'lucide-react';
import { Link } from 'react-router-dom';
import { toast } from 'sonner';
import { FAQSchema } from '@/components/schema/FAQSchema';
import { BreadcrumbSchema } from '@/components/schema/BreadcrumbSchema';

export const MarktpreisRechner = () => {
  const [formData, setFormData] = useState({
    assetklasse: '',
    plz: '',
    verkaufsflaeche: '',
    jahresmiete: '',
    wault: '',
    zustand: ''
  });
  
  const [result, setResult] = useState(null);
  const [loading, setLoading] = useState(false);
  const [showWaultCalculator, setShowWaultCalculator] = useState(false);
  const [waultMieter, setWaultMieter] = useState([
    { jahresmiete: '', restlaufzeit: '' }
  ]);

  const assetklassen = [
    { value: 'lebensmittelmarkt', label: 'Lebensmittelmarkt (Supermarkt, Vollsortimenter)' },
    { value: 'discounter', label: 'Discounter & Drogerie' },
    { value: 'baumarkt', label: 'Baumarkt & Gartencenter' },
    { value: 'fachmarkt', label: 'Fachmarkt (Elektro, Möbel, Sport)' },
    { value: 'fachmarktzentrum', label: 'Fachmarktzentrum' }
  ];

  const zustaende = [
    { value: 'neuwertig', label: 'Neuwertig (< 5 Jahre)' },
    { value: 'gut', label: 'Gut (5-15 Jahre, gepflegt)' },
    { value: 'renovierungsbedarf', label: 'Renovierungsbedarf (> 15 Jahre)' }
  ];

  const handleCalculate = async () => {
    // Validation
    if (!formData.assetklasse || !formData.plz || !formData.verkaufsflaeche || !formData.jahresmiete || !formData.zustand) {
      toast.error('Bitte füllen Sie alle Pflichtfelder aus');
      return;
    }

    setLoading(true);

    try {
      // Prepare data - convert empty strings to null for optional fields
      const requestData = {
        assetklasse: formData.assetklasse,
        plz: formData.plz,
        verkaufsflaeche: parseFloat(formData.verkaufsflaeche),
        jahresmiete: parseFloat(formData.jahresmiete),
        wault: formData.wault ? parseFloat(formData.wault) : null,
        zustand: formData.zustand
      };

      const response = await fetch(`${process.env.REACT_APP_BACKEND_URL}/api/tool/marktpreis`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(requestData),
      });

      if (!response.ok) {
        throw new Error('Berechnung fehlgeschlagen');
      }

      const data = await response.json();
      setResult(data);
      

  const calculateInlineWault = () => {
    // Calculate WAULT from mieter data
    let totalMiete = 0;
    let gewichteteLaufzeit = 0;
    
    for (const mieter of waultMieter) {
      const miete = parseFloat(mieter.jahresmiete) || 0;
      const laufzeit = parseFloat(mieter.restlaufzeit) || 0;
      
      if (miete > 0 && laufzeit > 0) {
        totalMiete += miete;
        gewichteteLaufzeit += miete * laufzeit;
      }
    }
    
    if (totalMiete === 0) {
      toast.error('Bitte geben Sie mindestens einen Mieter mit Miete und Restlaufzeit ein');
      return;
    }
    
    const wault = gewichteteLaufzeit / totalMiete;
    
    // Transfer to main form
    setFormData({...formData, wault: wault.toFixed(1)});
    setShowWaultCalculator(false);
    toast.success(`WAULT berechnet: ${wault.toFixed(1)} Jahre und übertragen!`);
  };
  
  const addMieter = () => {
    setWaultMieter([...waultMieter, { jahresmiete: '', restlaufzeit: '' }]);
  };
  
  const removeMieter = (index) => {
    if (waultMieter.length > 1) {
      setWaultMieter(waultMieter.filter((_, i) => i !== index));
    }
  };
  
  const updateMieter = (index, field, value) => {
    const updated = [...waultMieter];
    updated[index][field] = value;
    setWaultMieter(updated);
  };

      // Scroll to result
      setTimeout(() => {
        document.getElementById('result-section')?.scrollIntoView({ behavior: 'smooth' });
      }, 100);
      
    } catch (error) {
      console.error('Error:', error);
      toast.error('Fehler bei der Berechnung. Bitte versuchen Sie es erneut.');
    } finally {
      setLoading(false);
    }
  };

  const calculateInlineWault = () => {
    // Calculate WAULT from mieter data
    let totalMiete = 0;
    let gewichteteLaufzeit = 0;
    
    for (const mieter of waultMieter) {
      const miete = parseFloat(mieter.jahresmiete) || 0;
      const laufzeit = parseFloat(mieter.restlaufzeit) || 0;
      
      if (miete > 0 && laufzeit > 0) {
        totalMiete += miete;
        gewichteteLaufzeit += miete * laufzeit;
      }
    }
    
    if (totalMiete === 0) {
      toast.error('Bitte geben Sie mindestens einen Mieter mit Miete und Restlaufzeit ein');
      return;
    }
    
    const wault = gewichteteLaufzeit / totalMiete;
    
    // Transfer to main form
    setFormData({...formData, wault: wault.toFixed(1)});
    setShowWaultCalculator(false);
    toast.success(`WAULT berechnet: ${wault.toFixed(1)} Jahre und übertragen!`);
  };
  
  const addMieter = () => {
    setWaultMieter([...waultMieter, { jahresmiete: '', restlaufzeit: '' }]);
  };
  
  const removeMieter = (index) => {
    if (waultMieter.length > 1) {
      setWaultMieter(waultMieter.filter((_, i) => i !== index));
    }
  };
  
  const updateMieter = (index, field, value) => {
    const updated = [...waultMieter];
    updated[index][field] = value;
    setWaultMieter(updated);
  };

  const getBenchmarkColor = (benchmark) => {
    if (benchmark.includes('Über')) return 'text-green-600';
    if (benchmark.includes('Unter')) return 'text-red-600';
    return 'text-gray-600';
  };

  const getBenchmarkBg = (benchmark) => {
    if (benchmark.includes('Über')) return 'bg-green-50 border-green-200';
    if (benchmark.includes('Unter')) return 'bg-red-50 border-red-200';
    return 'bg-gray-50 border-gray-200';
  };

  const faqData = [
    {
      question: "Wie genau ist die Berechnung des Marktpreisrechners?",
      answer: "Die Berechnung basiert auf aktuellen Transaktionsdaten und typischen Renditen f\u00fcr Handelsimmobilien. Die Genauigkeit liegt bei ca. \u00b110-15%, abh\u00e4ngig von Objekttyp und Standort. F\u00fcr eine pr\u00e4zise Bewertung empfehlen wir eine pers\u00f6nliche Ersteinsch\u00e4tzung durch unseren Experten."
    },
    {
      question: "Welche Faktoren beeinflussen den Preis am st\u00e4rksten?",
      answer: "Die drei wichtigsten Faktoren sind: 1) Jahresmiete (bestimmt das Cashflow-Potenzial), 2) WAULT (Restlaufzeit der Mietvertr\u00e4ge \u2013 je l\u00e4nger, desto h\u00f6her der Preis), und 3) Standort (PLZ-Gebiet mit unterschiedlicher Nachfrage). Ein WAULT von 8+ Jahren kann den Preis um 10-20% steigern."
    },
    {
      question: "Was ist der Unterschied zu einem Verkehrswertgutachten?",
      answer: "Ein Verkehrswertgutachten ist eine detaillierte, rechtssichere Bewertung durch einen zertifizierten Sachverst\u00e4ndigen (Kosten: 2.000-5.000\u20ac). Unser Rechner liefert eine schnelle Orientierung f\u00fcr die Verkaufsvorbereitung. F\u00fcr Finanzierungen oder gerichtliche Zwecke ist ein Gutachten erforderlich."
    },
    {
      question: "Wie wird der WAULT in die Berechnung einbezogen?",
      answer: "Der WAULT (Weighted Average Unexpired Lease Term) misst die durchschnittliche Restlaufzeit aller Mietvertr\u00e4ge. Objekte mit WAULT > 8 Jahren werden mit h\u00f6heren Renditeabschl\u00e4gen bewertet (= h\u00f6herer Preis), da sie mehr Sicherheit bieten. Ein WAULT unter 5 Jahren f\u00fchrt zu Renditeaufschl\u00e4gen (= niedrigerer Preis)."
    },
    {
      question: "Was bedeutet die Preisspanne im Ergebnis?",
      answer: "Die Preisspanne zeigt den realistischen Verkaufspreis-Korridor. Der untere Wert ist der konservative Mindestpreis (Worst Case), der obere Wert der optimistische Maximalpreis (Best Case). Der tats\u00e4chliche Verkaufspreis liegt meist im mittleren Bereich, abh\u00e4ngig von Verhandlungsgeschick und K\u00e4ufernachfrage."
    },
    {
      question: "Werden meine Daten gespeichert oder weitergegeben?",
      answer: "Nein. Die Berechnung erfolgt vollst\u00e4ndig anonym. Ihre Objektdaten werden nicht gespeichert oder an Dritte weitergegeben. Erst wenn Sie uns \u00fcber das Kontaktformular kontaktieren, erfassen wir Ihre Daten gem\u00e4\u00df unserer Datenschutzerkl\u00e4rung."
    },
    {
      question: "Was sollte ich nach der Berechnung tun?",
      answer: "1) Ersteinsch\u00e4tzung anfordern: F\u00fcr eine pr\u00e4zise Bewertung kontaktieren Sie uns f\u00fcr ein kostenloses Erstgespr\u00e4ch. 2) WAULT pr\u00fcfen: Falls Ihr WAULT unter 5 Jahren liegt, erw\u00e4gen Sie Mietvertragsverl\u00e4ngerungen vor dem Verkauf. 3) Verkaufsbereitschaft testen: Nutzen Sie unseren Readiness-Check, um zu pr\u00fcfen, ob Ihr Objekt verkaufsbereit ist."
    }
  ];

  const breadcrumbItems = [
    { name: "Home", url: `${window.location.origin}/` },
    { name: "Tools", url: `${window.location.origin}/tools` },
    { name: "Live-Marktpreisrechner", url: `${window.location.origin}/tools/marktpreis` }
  ];

  return (
    <div className="min-h-screen flex flex-col">
      <FAQSchema faqs={faqData} />
      <BreadcrumbSchema items={breadcrumbItems} />
      <SEO 
        title="Live-Marktpreisrechner – Sofortige Werteinschätzung Ihrer Handelsimmobilie"
        description="Ermitteln Sie in 60 Sekunden den Marktwert Ihrer Handelsimmobilie. Kostenloser Rechner mit Benchmark-Vergleich und professioneller Analyse."
        url="/tools/marktpreis"
      />
      <Navbar />
      <main className="flex-grow bg-gray-50 py-12">
        <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8">
          {/* Hero */}
          <div className="text-center mb-12">
            <div className="w-20 h-1 bg-gradient-to-r from-[#D4A853] to-[#F0C870] mb-6 mx-auto"></div>
            <h1 className="text-4xl md:text-5xl font-bold mb-6" style={{ color: 'var(--navy-900)' }}>
              Live-Marktpreisrechner
            </h1>
            <p className="text-lg leading-relaxed max-w-3xl mx-auto" style={{ color: 'var(--gray-700)' }}>
              Erhalten Sie in 60 Sekunden eine realistische Einschätzung des Marktwerts Ihrer Handelsimmobilie.
              Kostenlos und unverbindlich.
            </p>
          </div>

          {/* Explanatory Content Section */}
          <Card className="glass-card p-8 mb-8 bg-[#EFF6FF]" data-testid="marktpreis-info-card">
            <h2 className="text-2xl font-semibold mb-4" style={{ color: 'var(--primary-700)' }}>
              Was ist der Live-Marktpreisrechner?
            </h2>
            <p className="text-base mb-4" style={{ color: 'var(--secondary-700)' }}>
              Der <strong>Live-Marktpreisrechner</strong> ist ein spezialisiertes Tool, das Ihnen in wenigen Sekunden 
              eine fundierte Einschätzung des aktuellen Marktwerts Ihrer Handelsimmobilie liefert. Basierend auf 
              Transaktionsdaten und aktuellen Marktpreisen erhalten Sie eine realistische Preisspanne.
            </p>
            <h3 className="text-xl font-semibold mb-3 mt-6" style={{ color: 'var(--primary-700)' }}>
              Wie funktioniert die Berechnung?
            </h3>
            <p className="text-base mb-4" style={{ color: 'var(--secondary-700)' }}>
              Unser Algorithmus berücksichtigt <strong>mehrere Faktoren</strong>, um den Marktwert zu ermitteln:
            </p>
            <ul className="space-y-2 mb-6">
              <li className="flex items-start gap-2">
                <div className="w-1.5 h-1.5 rounded-full mt-2" style={{ backgroundColor: 'var(--gold-600)' }}></div>
                <p style={{ color: 'var(--secondary-700)' }}>
                  <strong>Assetklasse & Standort:</strong> Je nach Objekttyp und PLZ-Gebiet gelten unterschiedliche Marktpreise
                </p>
              </li>
              <li className="flex items-start gap-2">
                <div className="w-1.5 h-1.5 rounded-full mt-2" style={{ backgroundColor: 'var(--gold-600)' }}></div>
                <p style={{ color: 'var(--secondary-700)' }}>
                  <strong>Jahresmiete & Rendite:</strong> Die Nettoanfangsrendite (NIY) ist der wichtigste Preisfaktor
                </p>
              </li>
              <li className="flex items-start gap-2">
                <div className="w-1.5 h-1.5 rounded-full mt-2" style={{ backgroundColor: 'var(--gold-600)' }}></div>
                <p style={{ color: 'var(--secondary-700)' }}>
                  <strong>WAULT (Mietvertragslaufzeit):</strong> Längere Restlaufzeiten = höhere Preise
                </p>
              </li>
              <li className="flex items-start gap-2">
                <div className="w-1.5 h-1.5 rounded-full mt-2" style={{ backgroundColor: 'var(--gold-600)' }}></div>
                <p style={{ color: 'var(--secondary-700)' }}>
                  <strong>Objektzustand:</strong> Neuwertige Objekte erzielen Premiumpreise
                </p>
              </li>
              <li className="flex items-start gap-2">
                <div className="w-1.5 h-1.5 rounded-full mt-2" style={{ backgroundColor: 'var(--gold-600)' }}></div>
                <p style={{ color: 'var(--secondary-700)' }}>
                  <strong>Marktdaten:</strong> Aktuelle Transaktionspreise aus vergleichbaren Verkäufen
                </p>
              </li>
            </ul>
            <h3 className="text-xl font-semibold mb-3" style={{ color: 'var(--primary-700)' }}>
              Warum ist dieser Rechner sinnvoll?
            </h3>
            <p className="text-base" style={{ color: 'var(--secondary-700)' }}>
              <strong>Schnelle Orientierung:</strong> Sie erhalten sofort eine Preisspanne, ohne auf ein Gutachten warten zu müssen. 
              <strong> Realistische Erwartungen:</strong> Vermeiden Sie überzogene Preisvorstellungen, die den Verkauf verzögern. 
              <strong> Verkaufsbereitschaft:</strong> Prüfen Sie, ob Ihre Immobilie bereits verkaufsreif ist (WAULT, Zustand). 
              <strong> Kostenlos & unverbindlich:</strong> Keine versteckten Kosten, keine Verpflichtung.
            </p>
          </Card>

          {/* Form */}
          <Card className="glass-card p-8 md:p-10 mb-8">
            <div className="flex items-center gap-3 mb-6">
              <div className="w-12 h-12 rounded-full flex items-center justify-center" style={{ background: 'linear-gradient(135deg, #D4A853 0%, #F0C870 100%)' }}>
                <Calculator className="h-6 w-6 text-white" />
              </div>
              <h2 className="text-2xl font-bold" style={{ color: 'var(--navy-800)' }}>Ihre Objektdaten</h2>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
              {/* Assetklasse */}
              <div>
                <Label htmlFor="assetklasse" className="text-base font-semibold mb-2" style={{ color: 'var(--navy-700)' }}>
                  Assetklasse <span className="text-red-500">*</span>
                </Label>
                <Select value={formData.assetklasse} onValueChange={(value) => setFormData({...formData, assetklasse: value})}>
                  <SelectTrigger className="h-12" data-testid="select-assetklasse">
                    <SelectValue placeholder="Bitte wählen" />
                  </SelectTrigger>
                  <SelectContent data-testid="select-assetklasse-content">
                    {assetklassen.map((ak) => (
                      <SelectItem key={ak.value} value={ak.value} data-testid={`asset-option-${ak.value}`}>{ak.label}</SelectItem>
                    ))}
                  </SelectContent>
                </Select>
              </div>

              {/* PLZ */}
              <div>
                <Label htmlFor="plz" className="text-base font-semibold mb-2" style={{ color: 'var(--navy-700)' }}>
                  Postleitzahl <span className="text-red-500">*</span>
                </Label>
                <Input
                  id="plz"
                  type="text"
                  placeholder="z.B. 50667"
                  value={formData.plz}
                  onChange={(e) => setFormData({...formData, plz: e.target.value})}
                  className="h-12"
                  maxLength={5}
                />
              </div>

              {/* Verkaufsfläche */}
              <div>
                <Label htmlFor="verkaufsflaeche" className="text-base font-semibold mb-2" style={{ color: 'var(--navy-700)' }}>
                  Verkaufsfläche (qm) <span className="text-red-500">*</span>
                </Label>
                <Input
                  id="verkaufsflaeche"
                  type="number"
                  placeholder="z.B. 800"
                  value={formData.verkaufsflaeche}
                  onChange={(e) => setFormData({...formData, verkaufsflaeche: e.target.value})}
                  className="h-12"
                />
              </div>

              {/* Jahresmiete */}
              <div>
                <Label htmlFor="jahresmiete" className="text-base font-semibold mb-2" style={{ color: 'var(--navy-700)' }}>
                  Jahresmiete (€) <span className="text-red-500">*</span>
                </Label>
                <Input
                  id="jahresmiete"
                  type="number"
                  placeholder="z.B. 120000"
                  value={formData.jahresmiete}
                  onChange={(e) => setFormData({...formData, jahresmiete: e.target.value})}
                  className="h-12"
                />
              </div>

              {/* WAULT */}
              <div className="md:col-span-2">
                <Label htmlFor="wault" className="text-base font-semibold mb-2" style={{ color: 'var(--navy-700)' }}>
                  WAULT (Jahre) <span className="text-gray-400 text-sm font-normal">(optional)</span>
                </Label>
                <div className="flex gap-2">
                  <Input
                    id="wault"
                    type="number"
                    step="0.1"
                    placeholder="z.B. 8.5"
                    value={formData.wault}
                    onChange={(e) => setFormData({...formData, wault: e.target.value})}
                    className="h-12 flex-1"
                  />
                  <Button
                    type="button"
                    variant="outline"
                    onClick={() => setShowWaultCalculator(!showWaultCalculator)}
                    className="h-12 px-4"
                    style={{ borderColor: 'var(--navy-600)', color: 'var(--navy-600)' }}
                  >
                    <Calculator className="h-4 w-4 mr-2" />
                    {showWaultCalculator ? 'Schließen' : 'Berechnen'}
                  </Button>
                </div>
                <p className="text-xs mt-1" style={{ color: 'var(--gray-500)' }}>Falls bekannt. Ansonsten wird ein Durchschnittswert verwendet.</p>
                
                {/* Inline WAULT Calculator */}
                {showWaultCalculator && (
                  <div className="mt-4 p-4 bg-blue-50 rounded-lg border border-blue-200">
                    <h4 className="font-bold mb-3" style={{ color: 'var(--navy-800)' }}>WAULT berechnen</h4>
                    {waultMieter.map((mieter, index) => (
                      <div key={index} className="grid grid-cols-[1fr_1fr_auto] gap-2 mb-2">
                        <Input
                          type="number"
                          placeholder="Jahresmiete €"
                          value={mieter.jahresmiete}
                          onChange={(e) => updateMieter(index, 'jahresmiete', e.target.value)}
                          className="h-10"
                        />
                        <Input
                          type="number"
                          step="0.1"
                          placeholder="Restlaufzeit (Jahre)"
                          value={mieter.restlaufzeit}
                          onChange={(e) => updateMieter(index, 'restlaufzeit', e.target.value)}
                          className="h-10"
                        />
                        {waultMieter.length > 1 && (
                          <Button
                            type="button"
                            variant="outline"
                            size="sm"
                            onClick={() => removeMieter(index)}
                            className="h-10 px-3"
                          >
                            ✕
                          </Button>
                        )}
                      </div>
                    ))}
                    <div className="flex gap-2 mt-3">
                      <Button
                        type="button"
                        variant="outline"
                        size="sm"
                        onClick={addMieter}
                        className="flex-1"
                      >
                        + Mieter hinzufügen
                      </Button>
                      <Button
                        type="button"
                        onClick={calculateInlineWault}
                        className="flex-1"
                        style={{ background: 'var(--navy-600)', color: 'white' }}
                      >
                        WAULT berechnen & übertragen
                      </Button>
                    </div>
                  </div>
                )}
              </div>

              {/* Zustand */}
              <div>
                <Label htmlFor="zustand" className="text-base font-semibold mb-2" style={{ color: 'var(--navy-700)' }}>
                  Objektzustand <span className="text-red-500">*</span>
                </Label>
                <Select value={formData.zustand} onValueChange={(value) => setFormData({...formData, zustand: value})}>
                  <SelectTrigger className="h-12">
                    <SelectValue placeholder="Bitte wählen" />
                  </SelectTrigger>
                  <SelectContent>
                    {zustaende.map((z) => (
                      <SelectItem key={z.value} value={z.value}>{z.label}</SelectItem>
                    ))}
                  </SelectContent>
                </Select>
              </div>
            </div>

            <div className="mt-8 flex flex-col sm:flex-row gap-4">
              <Button
                onClick={handleCalculate}
                disabled={loading}
                className="flex-1 btn-gold-gradient text-white border-0 font-semibold py-6 text-lg"
                data-testid="calculate-button"
              >
                {loading ? 'Berechnung läuft...' : 'Marktwert berechnen'}
                {!loading && <TrendingUp className="ml-2 h-5 w-5" />}
              </Button>
            </div>

            <div className="mt-6 flex items-start gap-2 p-4 bg-blue-50 rounded-lg">
              <Info className="h-5 w-5 mt-0.5" style={{ color: 'var(--navy-600)' }} />
              <p className="text-sm" style={{ color: 'var(--navy-700)' }}>
                Die Berechnung basiert auf aktuellen Marktdaten und vergleichbaren Transaktionen. Für eine detaillierte Bewertung empfehlen wir eine persönliche Analyse.
              </p>
            </div>
          </Card>

          {/* Result */}
          {result && (
            <div id="result-section">
              <Card className="glass-card p-8 md:p-10 mb-8" style={{ background: 'linear-gradient(to bottom, white 0%, #f9fafb 100%)', border: '2px solid var(--gold-600)' }}>
                <div className="text-center mb-8">
                  <div className="flex items-center justify-center gap-2 mb-4">
                    <CheckCircle2 className="h-8 w-8" style={{ color: 'var(--gold-600)' }} />
                    <h2 className="text-3xl font-bold" style={{ color: 'var(--navy-900)' }}>Ihre Marktwert-Einschätzung</h2>
                  </div>
                </div>

                {/* Main Price */}
                <div className="text-center mb-8 p-6 bg-white rounded-xl shadow-lg">
                  <p className="text-sm font-semibold mb-2" style={{ color: 'var(--gray-600)' }}>Geschätzter Marktwert</p>
                  <p className="text-5xl md:text-6xl font-bold mb-2" style={{ color: 'var(--navy-900)' }}>
                    {result.estimated_price.toLocaleString('de-DE')} €
                  </p>
                  <p className="text-lg" style={{ color: 'var(--gray-600)' }}>
                    Preisspanne: {result.price_range.min.toLocaleString('de-DE')} € - {result.price_range.max.toLocaleString('de-DE')} €
                  </p>
                </div>

                {/* Details Grid */}
                <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-8">
                  <Card className="p-6 text-center bg-white">
                    <p className="text-sm font-semibold mb-2" style={{ color: 'var(--gray-600)' }}>Preis pro qm VKF</p>
                    <p className="text-3xl font-bold" style={{ color: 'var(--navy-900)' }}>
                      {result.price_per_sqm.toLocaleString('de-DE')} €
                    </p>
                  </Card>
                  
                  <Card className="p-6 text-center bg-white">
                    <p className="text-sm font-semibold mb-2" style={{ color: 'var(--gray-600)' }}>Nettoanfangsrendite</p>
                    <p className="text-3xl font-bold mb-1" style={{ color: 'var(--navy-900)' }}>
                      {result.yield_rate.toFixed(2)} %
                    </p>
                    {result.yield_range && (
                      <p className="text-sm" style={{ color: 'var(--gray-600)' }}>
                        Spanne: {result.yield_range.min}% - {result.yield_range.max}%
                      </p>
                    )}
                  </Card>
                  
                  <Card className={`p-6 text-center border-2 ${getBenchmarkBg(result.benchmark)}`}>
                    <p className="text-sm font-semibold mb-2" style={{ color: 'var(--gray-600)' }}>Markt-Vergleich</p>
                    <p className={`text-xl font-bold ${getBenchmarkColor(result.benchmark)}`}>
                      {result.benchmark}
                    </p>
                  </Card>
                </div>

                {/* Factors */}
                <div className="mb-8">
                  <h3 className="text-xl font-bold mb-4" style={{ color: 'var(--navy-800)' }}>Bewertungsfaktoren</h3>
                  <div className="space-y-3">
                    {result.factors.map((factor, i) => (
                      <div key={i} className="flex items-center justify-between p-4 bg-white rounded-lg">
                        <span className="font-semibold" style={{ color: 'var(--navy-700)' }}>{factor.name}</span>
                        <span className="text-sm" style={{ color: 'var(--gray-600)' }}>{factor.description}</span>
                      </div>
                    ))}
                  </div>
                </div>

                {/* WAULT Scenarios */}
                {result.wault_scenarios && result.wault_scenarios.length > 0 && (
                  <div className="mb-8">
                    <h3 className="text-2xl font-bold mb-4" style={{ color: 'var(--navy-800)' }}>
                      💡 Wert-Szenarien nach WAULT
                    </h3>
                    <p className="text-sm mb-6" style={{ color: 'var(--gray-600)' }}>
                      Sehen Sie, wie sich der Verkaufspreis mit unterschiedlicher Mietbindung ändert:
                    </p>
                    
                    <div className="overflow-x-auto">
                      <table className="w-full">
                        <thead>
                          <tr className="border-b-2" style={{ borderColor: 'var(--gold-600)' }}>
                            <th className="text-left py-3 px-4 font-bold" style={{ color: 'var(--navy-800)' }}>WAULT</th>
                            <th className="text-right py-3 px-4 font-bold" style={{ color: 'var(--navy-800)' }}>Geschätzter Preis</th>
                            <th className="text-right py-3 px-4 font-bold" style={{ color: 'var(--navy-800)' }}>Rendite</th>
                            <th className="text-right py-3 px-4 font-bold" style={{ color: 'var(--navy-800)' }}>Differenz</th>
                          </tr>
                        </thead>
                        <tbody>
                          {result.wault_scenarios.map((scenario, i) => {
                            const isCurrentWault = Math.abs(scenario.wault_years - result.wault_used) < 0.5;
                            const rowClass = isCurrentWault ? 'bg-blue-50 font-semibold' : 'hover:bg-gray-50';
                            const diffColor = scenario.price_diff > 0 ? 'text-green-600' : scenario.price_diff < 0 ? 'text-red-600' : 'text-gray-600';
                            
                            return (
                              <tr key={i} className={`border-b ${rowClass}`} style={{ borderColor: 'var(--gray-200)' }}>
                                <td className="py-4 px-4" style={{ color: 'var(--navy-700)' }}>
                                  {scenario.wault_years} Jahre {isCurrentWault && <span className="text-xs ml-2 px-2 py-1 bg-blue-200 rounded">Aktuell</span>}
                                </td>
                                <td className="text-right py-4 px-4 font-semibold" style={{ color: 'var(--navy-900)' }}>
                                  € {scenario.estimated_price.toLocaleString('de-DE')}
                                </td>
                                <td className="text-right py-4 px-4" style={{ color: 'var(--gray-700)' }}>
                                  {scenario.yield_rate}%
                                </td>
                                <td className={`text-right py-4 px-4 font-semibold ${diffColor}`}>
                                  {scenario.price_diff >= 0 ? '+' : ''}{scenario.price_diff.toLocaleString('de-DE')} €
                                  <span className="text-xs ml-2">({scenario.price_diff_percent >= 0 ? '+' : ''}{scenario.price_diff_percent}%)</span>
                                </td>
                              </tr>
                            );
                          })}
                        </tbody>
                      </table>
                    </div>
                    
                    {/* Insight Box */}
                    {result.wault_scenarios.find(s => s.wault_years === 10) && (
                      <div className="mt-6 p-6 bg-green-50 rounded-lg border-2 border-green-200">
                        <h4 className="text-lg font-bold mb-2" style={{ color: 'var(--success-700)' }}>
                          💰 Optimierungs-Potenzial
                        </h4>
                        <p className="text-base leading-relaxed" style={{ color: 'var(--gray-700)' }}>
                          Mit einer <strong>Mietvertragsverlängerung von {result.wault_used.toFixed(0)} auf 10 Jahre</strong> könnte 
                          Ihr Verkaufspreis um bis zu <strong className="text-green-600">
                            € {result.wault_scenarios.find(s => s.wault_years === 10).price_diff.toLocaleString('de-DE')}
                          </strong> ({result.wault_scenarios.find(s => s.wault_years === 10).price_diff_percent}%) steigen!
                        </p>
                      </div>
                    )}
                  </div>
                )}

                {/* CTA */}
                <div className="text-center">
                  <p className="text-lg mb-6" style={{ color: 'var(--gray-700)' }}>
                    Möchten Sie eine <strong>detaillierte, professionelle Bewertung</strong> mit Marktanalyse und Verkaufsstrategie?
                  </p>
                  <Link to="/ersteinschaetzung">
                    <Button className="btn-gold-gradient text-white border-0 font-semibold px-10 py-7 text-lg shadow-2xl">
                      Kostenlose Detailbewertung anfordern
                      <ArrowRight className="ml-2 h-6 w-6" />
                    </Button>
                  </Link>
                </div>
              </Card>

              {/* Andreas Contact */}
              <Card className="glass-card p-8">
                <div className="grid grid-cols-1 md:grid-cols-[auto_1fr] gap-6 items-center">
                  <img 
                    src="https://customer-assets.emergentagent.com/job_commprop-advisor/artifacts/zb797gk8_Andreas%20Heinrichs%20Hochkant%20Webseite.png" 
                    alt="Andreas Heinrichs – Ihr persönlicher Ansprechpartner für die Bewertung und den Verkauf Ihrer Handelsimmobilie"
                    className="w-32 h-32 rounded-full object-cover ring-4 ring-[#D4A853] mx-auto md:mx-0"
                  />
                  <div>
                    <h3 className="text-xl font-bold mb-2" style={{ color: 'var(--navy-900)' }}>Ihr Ansprechpartner: Andreas Heinrichs</h3>
                    <p className="mb-4" style={{ color: 'var(--gray-700)' }}>
                      Geschäftsführer & Spezialist für Einzelhandelsimmobilien. Ich begleite Sie persönlich durch den gesamten Verkaufsprozess.
                    </p>
                    <Link to="/kontakt">
                      <Button variant="outline" className="font-semibold" style={{ borderColor: 'var(--gold-600)', color: 'var(--gold-600)' }}>
                        Jetzt Kontakt aufnehmen
                      </Button>
                    </Link>
                  </div>
                </div>
              </Card>
            </div>
          )}

          {/* FAQ Section */}
          <Card className="glass-card p-8 mt-8" data-testid="marktpreis-faq-card">
            <h2 className="text-2xl font-semibold mb-6" style={{ color: 'var(--primary-700)' }}>
              Häufig gestellte Fragen (FAQ)
            </h2>
            <Accordion type="single" collapsible className="space-y-4">
              <AccordionItem value="faq-1" className="border rounded-lg px-4">
                <AccordionTrigger className="text-left font-semibold" style={{ color: 'var(--primary-700)' }}>
                  Wie genau ist die Berechnung des Marktpreisrechners?
                </AccordionTrigger>
                <AccordionContent className="text-base" style={{ color: 'var(--secondary-700)' }}>
                  Die Berechnung basiert auf aktuellen Transaktionsdaten und typischen Renditen für Handelsimmobilien. 
                  Die Genauigkeit liegt bei ca. ±10-15%, abhängig von Objekttyp und Standort. Für eine präzise Bewertung 
                  empfehlen wir eine persönliche Ersteinschätzung durch unseren Experten.
                </AccordionContent>
              </AccordionItem>

              <AccordionItem value="faq-2" className="border rounded-lg px-4">
                <AccordionTrigger className="text-left font-semibold" style={{ color: 'var(--primary-700)' }}>
                  Welche Faktoren beeinflussen den Preis am stärksten?
                </AccordionTrigger>
                <AccordionContent className="text-base" style={{ color: 'var(--secondary-700)' }}>
                  Die drei wichtigsten Faktoren sind: <strong>1) Jahresmiete</strong> (bestimmt das Cashflow-Potenzial), 
                  <strong>2) WAULT</strong> (Restlaufzeit der Mietverträge – je länger, desto höher der Preis), und 
                  <strong>3) Standort</strong> (PLZ-Gebiet mit unterschiedlicher Nachfrage). Ein WAULT von 8+ Jahren 
                  kann den Preis um 10-20% steigern.
                </AccordionContent>
              </AccordionItem>

              <AccordionItem value="faq-3" className="border rounded-lg px-4">
                <AccordionTrigger className="text-left font-semibold" style={{ color: 'var(--primary-700)' }}>
                  Was ist der Unterschied zu einem Verkehrswertgutachten?
                </AccordionTrigger>
                <AccordionContent className="text-base" style={{ color: 'var(--secondary-700)' }}>
                  Ein Verkehrswertgutachten ist eine detaillierte, rechtssichere Bewertung durch einen zertifizierten 
                  Sachverständigen (Kosten: 2.000-5.000€). Unser Rechner liefert eine schnelle Orientierung für die 
                  Verkaufsvorbereitung. Für Finanzierungen oder gerichtliche Zwecke ist ein Gutachten erforderlich.
                </AccordionContent>
              </AccordionItem>

              <AccordionItem value="faq-4" className="border rounded-lg px-4">
                <AccordionTrigger className="text-left font-semibold" style={{ color: 'var(--primary-700)' }}>
                  Wie wird der WAULT in die Berechnung einbezogen?
                </AccordionTrigger>
                <AccordionContent className="text-base" style={{ color: 'var(--secondary-700)' }}>
                  Der WAULT (Weighted Average Unexpired Lease Term) misst die durchschnittliche Restlaufzeit aller 
                  Mietverträge. <strong>Objekte mit WAULT &gt; 8 Jahren</strong> werden mit höheren Renditeabschlägen 
                  bewertet (= höherer Preis), da sie mehr Sicherheit bieten. Ein WAULT unter 5 Jahren führt zu 
                  Renditeaufschlägen (= niedrigerer Preis).
                </AccordionContent>
              </AccordionItem>

              <AccordionItem value="faq-5" className="border rounded-lg px-4">
                <AccordionTrigger className="text-left font-semibold" style={{ color: 'var(--primary-700)' }}>
                  Was bedeutet die Preisspanne im Ergebnis?
                </AccordionTrigger>
                <AccordionContent className="text-base" style={{ color: 'var(--secondary-700)' }}>
                  Die Preisspanne zeigt den realistischen Verkaufspreis-Korridor. Der <strong>untere Wert</strong> ist der 
                  konservative Mindestpreis (Worst Case), der <strong>obere Wert</strong> der optimistische Maximalpreis 
                  (Best Case). Der tatsächliche Verkaufspreis liegt meist im mittleren Bereich, abhängig von 
                  Verhandlungsgeschick und Käufernachfrage.
                </AccordionContent>
              </AccordionItem>

              <AccordionItem value="faq-6" className="border rounded-lg px-4">
                <AccordionTrigger className="text-left font-semibold" style={{ color: 'var(--primary-700)' }}>
                  Werden meine Daten gespeichert oder weitergegeben?
                </AccordionTrigger>
                <AccordionContent className="text-base" style={{ color: 'var(--secondary-700)' }}>
                  <strong>Nein.</strong> Die Berechnung erfolgt vollständig anonym. Ihre Objektdaten werden nicht 
                  gespeichert oder an Dritte weitergegeben. Erst wenn Sie uns über das Kontaktformular kontaktieren, 
                  erfassen wir Ihre Daten gemäß unserer Datenschutzerklärung.
                </AccordionContent>
              </AccordionItem>

              <AccordionItem value="faq-7" className="border rounded-lg px-4">
                <AccordionTrigger className="text-left font-semibold" style={{ color: 'var(--primary-700)' }}>
                  Was sollte ich nach der Berechnung tun?
                </AccordionTrigger>
                <AccordionContent className="text-base" style={{ color: 'var(--secondary-700)' }}>
                  <strong>1) Ersteinschätzung anfordern:</strong> Für eine präzise Bewertung kontaktieren Sie uns für 
                  ein kostenloses Erstgespräch. <strong>2) WAULT prüfen:</strong> Falls Ihr WAULT unter 5 Jahren liegt, 
                  erwägen Sie Mietvertragsverlängerungen vor dem Verkauf. <strong>3) Verkaufsbereitschaft testen:</strong> 
                  Nutzen Sie unseren Readiness-Check, um zu prüfen, ob Ihr Objekt verkaufsbereit ist.
                </AccordionContent>
              </AccordionItem>
            </Accordion>
          </Card>
        </div>
      </main>
      <Footer />
    </div>
  );
};

export default MarktpreisRechner;
